import * as React from 'react';
import * as _ from 'lodash';
import * as qs from 'query-string';
import * as moment from 'moment';
import { AxiosError } from 'axios';
import { Dispatch, connect } from 'react-redux';
import { IApplicationState, AppActionCreators, DonorSwapActionCreators, ISwapDonorsLookupDataResponse, ISwapProfileSearchResponse, ISwapDonorLookupData, ISwapDonorResponse, ISwapDonorLookUpDataResponse, ISwapDonorDeleteResponse, ISpecificSwapProfileSearchResponse, IDonorAliasDuplicateCheckResponse, IPairingRecipientDataResponse, IDonorConversionDataLookupResponse, IDonorConversionPostResponse, ExpertSystemActionCreators, IDonorSearchRequest, MicrositeActionCreators, IMicrositeListResponse } from '@nkr/store/index';
import { IBaseResponse, ICenterBase, ICenterCoordinator, IListItem, IStatusList, ISwapDonor, ITypeList, ICenterRecipient, IConvertDonationType, IMicrositeConvertDonationType, IMicrositeRecipientForList } from '@nkr/models/index';
import { IDonationTypeData, initialDonationTypeDataState } from '../../profile/models';
import { DonationType, DonorAction, HistogeneticsEntityType, MenuLocation, VoucherStatusType } from '@nkr/enums/index';
import { Button, Glyphicon } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { DonorSearchType } from '../donor-search-type-list';
import { downloadFile } from '@nkr/services/download-file';
import Search from './search';
import Grid from './grid';
import Drawer from 'rc-drawer';
import View from './view';
import ConvertDonorType from './convert-donor-type';
import DeleteDonorModal from './delete-donor-modal';
import SwapDonorsNav from '../nav';
import CheekSwabRequest, { CheekSwabType } from '@nkr/views/cheek-swab-request-form';
import ActionButtonRenderer from './action-button-renderer';
import OrderCheekSwabModal from '../modals/order-cheek-swab-modal';
import BulkCheekSwabModal from '../modals/bulk-cheek-swab-modal';
import VoucherHolderMicrositeRecipientModal from '../../donor-intake/components/voucher-holder-microsite-recipient-modal';
import { ConversionType } from '@nkr/enums/conversion-type';

interface IProps {
    activeKey: string,
    centerId: number,
    isAdmin: boolean
}

interface IStateProps {
    groupIsSuper: boolean
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    doAdminDonorSearch: (request: IDonorSearchRequest) => Promise<ISwapProfileSearchResponse>,
    doCenterDonorSearch: (request: IDonorSearchRequest) => Promise<ISwapProfileSearchResponse>,
    getSwapDonorsLookupData: (centerId: number) => Promise<ISwapDonorsLookupDataResponse>,
    doAdminSave: (data: ISwapDonor) => Promise<ISwapDonorResponse>,
    doCenterSave: (data: ISwapDonor) => Promise<ISwapDonorResponse>,
    getLookupData: (donorId: number, centerId: number) => Promise<ISwapDonorLookUpDataResponse>,
    doAdminDelete: (donorId: number, reasonCode: number, reason: string, initials: string) => Promise<ISwapDonorDeleteResponse>,
    doCenterDelete: (donorId: number, centerId: number, reasonCode: number, reason: string, initials: string) => Promise<ISwapDonorDeleteResponse>,
    adminSpecificDonor: (donorId: number) => Promise<ISpecificSwapProfileSearchResponse>,
    checkAlias: (donorId: number, alias: string) => Promise<IDonorAliasDuplicateCheckResponse>,
    sendSelfRegistrationInvite: (donorId: number) => Promise<IBaseResponse>,
    getPairingRecipientList: () => Promise<IPairingRecipientDataResponse>,
    savePairingRecipient: (centerId: number, donorId: number, recipientId: number) => Promise<IPairingRecipientDataResponse>,
    getConversionLookUpData: (donorId: number, centerId: number, isAdmin: boolean) => Promise<IDonorConversionDataLookupResponse>,
    convertDonor: (donorId: number, centerId: number, data: IConvertDonationType, isAdmin: boolean) => Promise<IDonorConversionPostResponse>,
    getPedsMicrositeByCenter: (centerId: number) => Promise<IMicrositeListResponse>,
    convertDonorToMicrositeVoucher: (data: IMicrositeConvertDonationType) => Promise<IDonorConversionPostResponse>,
    unlinkRecipient: (donorId: number) => Promise<IBaseResponse>,
    printRequisition: (orderId: number, entityTypeId: number) => Promise<any>
}

type TProps = IStateProps & IDispatchProps & IProps;

interface IState {
    list: ISwapDonor[],
    total: number,
    coordinatorList: ICenterCoordinator[],
    centerList: IListItem[],
    donationTypeList: IListItem[],
    donorTypeList: any[],
    rdnCenterList: ICenterBase[],
    recipientList: ICenterRecipient[],
    selectedIndex: number,
    filtered: boolean,
    fullName: string,
    alias: string,
    email: string,
    remote: number,
    dob: string,
    centerId: number,
    donorId: number,
    donatedStartDate: string,
    donatedEndDate: string,
    compatible: boolean,
    voucherStatus: number,
    statusList: IStatusList,
    typeList: ITypeList,
    view: {
        show: boolean,
        data: ISwapDonor,
        lookupData: ISwapDonorLookupData
    },
    isPaired: boolean,
    pairedRecipientId: number,
    donationTypeData: IDonationTypeData,
    pairedRecipientAlias: string,
    deleteModal: {
        show: boolean,
        donorId: number,
        donorAlias: string
    },
    cheekSwabModal: {
        show: boolean,
        type: CheekSwabType,
        donorId: number
    },
    orderCheekSwabModal: {
        show: boolean,
        donorId: number,
        centerId: number
    },
    bulkCheekSwabModal: {
        show: boolean,
        donorId: number
    },
    voucherHolderMicrositeRecipientModal: {
        show: boolean,
        donorId: number,
        donorName: string,
        patientList: IMicrositeRecipientForList[]
    }
}

class SwapDonorList extends React.Component<TProps, IState> {
    readonly state: IState = {
        list: [],
        total: 0,
        coordinatorList: [],
        centerList: [],
        donationTypeList: [],
        rdnCenterList: [],
        recipientList: [],
        selectedIndex: -1,
        filtered: false,
        donorTypeList: [
            { id: 1, description: 'Directed Donor' },
            { id: 2, description: 'Standard Voucher Donor' },
            { id: 3, description: 'Non-Directed Donor' },
            { id: 4, description: 'Family Voucher Donor' }
        ],
        fullName: '',
        alias: '',
        email: '',
        remote: DonorSearchType.All,
        dob: '',
        centerId: 0,
        donorId: 0,
        donatedStartDate: '',
        donatedEndDate: '',
        compatible: null,
        voucherStatus: VoucherStatusType.All,
        statusList: {
            active: true,
            inactive: true,
            donated: false,
            deleted: false
        },
        typeList: {
            ndd: true,
            sv: true,
            fv: true,
            bridge: true,
            dd: true,
            paired: true,
            remote: false
        },
        view: {
            show: false,
            data: null,
            lookupData: null
        },
        isPaired: false,
        pairedRecipientId: 0,
        donationTypeData: initialDonationTypeDataState,
        pairedRecipientAlias: '',
        deleteModal: {
            show: false,
            donorId: 0,
            donorAlias: ''
        },
        cheekSwabModal: {
            show: false,
            type: null,
            donorId: 0
        },
        orderCheekSwabModal: {
            show: false,
            donorId: 0,
            centerId: 0
        },
        bulkCheekSwabModal: {
            show: false,
            donorId: 0
        },
        voucherHolderMicrositeRecipientModal: {
            show: false,
            donorId: 0,
            donorName: '',
            patientList: []
        }
    }

    container: HTMLDivElement;

    saveContainer = (container: HTMLDivElement) => {
        this.container = container;
    };

    getContainer = () => {
        return this.container;
    }

    componentDidMount = () => {
        if (location.search.length > 0 || !this.props.isAdmin) {
            this.getData();
        } else {
            this.getLookUpDataOnly();
        }
    }

    getData = () => {
        let parsed = qs.parse(location.search.length > 0 ? location.search : encodeURI(""), { arrayFormat: 'bracket' });

        let centerId = this.props.centerId;

        if (parsed.center) {
            centerId = parseInt(parsed.center);
        }

        let initPayload = {
            centerId,
            fullName: parsed.fullName != null ? parsed.fullName : '',
            alias: parsed.alias != null ? parsed.alias : '',
            dob: parsed.dob != null ? parsed.dob : '',
            email: parsed.email != null ? parsed.email : '',
            remote: parsed.remote != null ? 1 : parsed.remote,
            donorId: parsed.did != null ? parseInt(parsed.did) : 0,
            statuses: {
                active: parsed.status != null ? parsed.status.indexOf('active') >= 0 : true,
                inactive: parsed.status != null ? parsed.status.indexOf('inactive') >= 0 : true,
                donated: parsed.status != null ? parsed.status.indexOf('donated') >= 0 : false,
                deleted: parsed.status != null ? parsed.status.indexOf('deleted') >= 0 : false
            },
            types: {
                ndd: parsed.type != null ? parsed.type.indexOf('ndd') >= 0 : true,
                sv: parsed.type != null ? parsed.type.indexOf('sv') >= 0 : true,
                fv: parsed.type != null ? parsed.type.indexOf('fv') >= 0 : true,
                bridge: parsed.type != null ? parsed.type.indexOf('bridge') >= 0 : true,
                dd: parsed.type != null ? parsed.type.indexOf('dd') >= 0 : true,
                paired: parsed.type != null ? parsed.type.indexOf('paired') >= 0 : true,
                remote: parsed.type != null ? parsed.type.indexOf('remote') >= 0 : true
            },
            donatedStartDate: parsed.donatedStartDate != null ? parsed.donatedStartDate : moment().subtract(12, 'month').format('YYYY-MM-DD'),
            donatedEndDate: parsed.donatedEndDate != null ? parsed.donatedEndDate : moment().format('YYYY-MM-DD'),
            compatible: parsed.compatible != null ? parsed.compatible == '1' : null,
            voucherStatus: parsed.voucherStatus != null ? parsed.voucherStatus : 0
        }

        let doSearch = this.props.isAdmin ? this.props.doAdminDonorSearch : this.props.doCenterDonorSearch;

        let request: IDonorSearchRequest = {
            centerId: initPayload.centerId,
            fullName: initPayload.fullName,
            alias: initPayload.alias,
            email: initPayload.email,
            remote: initPayload.remote,
            dob: initPayload.dob,
            statuses: initPayload.statuses,
            types: initPayload.types,
            donatedStartDate: initPayload.donatedStartDate,
            donatedEndDate: initPayload.donatedEndDate,
            compatible: initPayload.compatible,
            voucherStatus: initPayload.voucherStatus
        };

        this.props.showLoading("Getting donors, one moment please...").then(() => {
            Promise.all([
                doSearch(request),
                this.props.getSwapDonorsLookupData(centerId),
            ]).then(async ([listResponse, lookupListResponse]) => {
                if (listResponse.data.success && lookupListResponse.data.success) {
                    let { list, total } = listResponse.data.results;
                    let { coordinatorList, centerList, donationTypeList, rdnCenterList } = lookupListResponse.data.results;

                    let recipientList = [];

                    if (this.props.isAdmin) {
                        let recipientListResponse = await this.props.getPairingRecipientList();

                        if (recipientListResponse.data.success) {
                            recipientList = recipientListResponse.data.results.map(x => {
                                return {
                                    id: x.id, alias: x.alias, centerId: x.centerId, centerAlias: x.centerAlias, chip: x.isInChip
                                };
                            });
                        }
                    }

                    this.setState({
                        list,
                        total,
                        coordinatorList,
                        centerList,
                        donationTypeList,
                        recipientList,
                        rdnCenterList,
                        fullName: initPayload.fullName,
                        alias: initPayload.alias,
                        dob: initPayload.dob,
                        email: initPayload.email,
                        remote: initPayload.remote,
                        centerId: initPayload.centerId,
                        statusList: {
                            active: initPayload.statuses.active,
                            inactive: initPayload.statuses.inactive,
                            deleted: initPayload.statuses.deleted,
                            donated: initPayload.statuses.donated
                        },
                        typeList: {
                            sv: initPayload.types.sv,
                            fv: initPayload.types.fv,
                            bridge: initPayload.types.bridge,
                            ndd: initPayload.types.ndd,
                            dd: initPayload.types.dd,
                            paired: initPayload.types.paired,
                            remote: initPayload.types.remote
                        },
                        donorId: initPayload.donorId,
                        donatedStartDate: initPayload.donatedStartDate,
                        donatedEndDate: initPayload.donatedEndDate,
                        compatible: initPayload.compatible,
                        voucherStatus: initPayload.voucherStatus
                    }, () => {
                        this.setUrlParameters();

                        if (this.state.view.show) {
                            this.handleViewRegistration(this.state.view.data.donorId);
                        } else {
                            if (this.state.donorId > 0) {
                                this.handleViewRegistration(this.state.donorId);
                            }
                        }
                    });
                }
            }).finally(() => {
                this.props.hideLoading();
            });
        });
    }

    getLookUpDataOnly = () => {
        this.props.showLoading('Loading setup data, one moment please...').then(() => {
            Promise.all([
                this.props.getSwapDonorsLookupData(this.props.centerId),
                this.props.getPairingRecipientList()
            ])
                .then(([lookupDataResponse, recipientListResponse]) => {
                    if (lookupDataResponse.data.success && recipientListResponse.data.success) {
                        let { coordinatorList, centerList, donationTypeList, rdnCenterList } = lookupDataResponse.data.results;

                        let recipientList = recipientListResponse.data.results.map(x => {
                            return {
                                id: x.id, alias: x.alias, centerId: x.centerId, centerAlias: x.centerAlias, chip: x.isInChip
                            };
                        });

                        this.setState({
                            coordinatorList,
                            centerList,
                            donationTypeList,
                            rdnCenterList,
                            recipientList
                        });
                    }
                }).finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    setUrlParameters = () => {
        let { centerId, fullName, alias, email, remote, dob, donorId, statusList, typeList, donatedStartDate, donatedEndDate, compatible, voucherStatus } = this.state;

        let paramList = [];

        if (centerId > 0) {
            paramList.push('center=' + centerId);
        }

        if (statusList.active) {
            paramList.push('status[]=active');
        }
        if (statusList.inactive) {
            paramList.push('status[]=inactive');
        }

        if (statusList.deleted) {
            paramList.push('status[]=deleted');
        }

        if (statusList.donated) {
            paramList.push('status[]=donated');
        }

        if (typeList.sv) {
            paramList.push('type[]=sv');
        }

        if (typeList.fv) {
            paramList.push('type[]=fv');
        }

        if (typeList.bridge) {
            paramList.push('type[]=bridge');
        }

        if (typeList.ndd) {
            paramList.push('type[]=ndd');
        }

        if (typeList.dd) {
            paramList.push('type[]=dd');
        }

        if (typeList.paired) {
            paramList.push('type[]=paired');
        }

        if (typeList.remote) {
            paramList.push('type[]=remote');
        }

        if (fullName != '') {
            paramList.push('fullName=' + fullName);
        }

        if (alias != '') {
            paramList.push('alias=' + alias);
        }

        if (email != '') {
            paramList.push('email=' + email);
        }

        paramList.push('remote=' + remote);

        if (dob != null) {
            paramList.push('dob=' + dob);
        }

        if (donatedStartDate != '') {
            paramList.push('donatedStartDate=' + donatedStartDate);
        }

        if (donatedEndDate != '') {
            paramList.push('donatedEndDate=' + donatedEndDate);
        }

        if (compatible != null) {
            paramList.push('compatible=' + (compatible ? '1' : '0'));
        }

        if (voucherStatus != null) {
            paramList.push('voucherStatus=' + voucherStatus);
        }

        paramList.push('did=' + donorId);

        let params = paramList.join('&');

        let newUrl = this.props.isAdmin == false ?
            '/center/' + this.props.centerId + '/donors/swap?' + params
            :
            '/admin/donors?' + params
            ;

        window.history.pushState({}, '', newUrl);
    }

    handleSpecificDonorSearch = (id: number) => {
        this.props.adminSpecificDonor(id).then((res) => {
            if (res.data.success) {
                if (res.data.results.total > 0) {
                    let donorData = res.data.results.donor;

                    let data: ISwapDonor = {
                        ...donorData,
                        originalFromDate: donorData.donationStartDate,
                        originalToDate: donorData.donationEndDate,
                        centerId: donorData.centerId
                    };

                    this.props.getLookupData(id, data.centerId).then(response => {
                        if (response.data.success) {
                            let { donorChainId, clusterNumber, position } = response.data.results;

                            data = {
                                ...data,
                                donorChainId,
                                clusterNumber,
                                position
                            }

                            this.setState({
                                view: {
                                    show: true,
                                    data,
                                    lookupData: response.data.results
                                }
                            });
                        }
                    });
                }
            }
        })
    }

    handleFilter = (fullName: string, alias: string, email: string, remote: number, dob: string, statusList: IStatusList, types: ITypeList, centerId: number, donatedStartDate: string, donatedEndDate: string, compatible: boolean, voucherStatus: VoucherStatusType) => {
        let request: IDonorSearchRequest = {
            centerId,
            fullName,
            alias,
            email,
            remote,
            dob,
            statuses: statusList,
            types,
            donatedStartDate,
            donatedEndDate,
            compatible,
            voucherStatus
        };

        let doSearch = this.props.isAdmin ? this.props.doAdminDonorSearch(request) : this.props.doCenterDonorSearch(request);

        this.props.showLoading("Searching, one moment please...").then(() => {
            doSearch
                .then(response => {
                    if (response.data.success) {
                        let { list, total } = response.data.results;

                        this.setState({
                            list,
                            total,
                            filtered: fullName != '' || alias != '' || email != '' || remote != DonorSearchType.All || dob != '' || statusList.active
                        }, () => {
                            this.setUrlParameters();
                        });
                    }
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleFilterChange = (name: string, value: any) => {
        let state = _.cloneDeep(this.state);

        if (name == 'status') {
            state.statusList[value] = !this.state.statusList[value];
        } else if (name == 'types') {
            state.typeList[value] = !this.state.typeList[value];
        } else {
            state[name] = value;
        }

        this.setState({
            ...state
        });
    }

    handleListChange = (swapList: ISwapDonor[]) => {
        let { typeList, statusList } = this.state;

        let filteredList: ISwapDonor[];

        filteredList = _.cloneDeep(swapList);

        if (!statusList.deleted) {
            filteredList = filteredList.filter(x => x.isDeleted == false);
        }

        if (!typeList.ndd) {
            filteredList = filteredList.filter(x => x.donationTypeId != DonationType.NonDirectedDonor);
        }

        if (!typeList.sv) {
            filteredList = filteredList.filter(x => x.donationTypeId != DonationType.StandardVoucher &&
                x.donationTypeId != DonationType.RealTimeSwapFailure &&
                x.donationTypeId != DonationType.SwapSaver);
        }

        if (!typeList.fv) {
            filteredList = filteredList.filter(x => x.donationTypeId != DonationType.FamilyVoucher &&
                x.donationTypeId != DonationType.RealTimeSwapFailure &&
                x.donationTypeId != DonationType.SwapSaver);
        }

        if (!typeList.paired) {
            filteredList = filteredList.filter(x => x.donationTypeId != DonationType.RemoteDirect &&
                x.donationTypeId != DonationType.KflInternalDirect &&
                x.donationTypeId != DonationType.KflRemoteDirect &&
                x.donationTypeId != DonationType.NkrInternalDirect &&
                x.donationTypeId != DonationType.NonDirectedDonor &&
                x.donationTypeId != DonationType.DirectedDonor);
        }

        if (!typeList.remote) {
            filteredList = filteredList.filter(x => x.donationCenterId == x.recipientCenterId);
        }

        if (statusList.active && !statusList.inactive) {
            filteredList = _.cloneDeep(swapList.filter(x => x.isActive == true));
        }

        if (!statusList.active && statusList.inactive) {
            filteredList = filteredList = filteredList.filter(x => x.isActive == false);
        }

        if (!statusList.active && !statusList.inactive && statusList.donated) {
            filteredList = filteredList = filteredList.filter(x => x.donated != '--');
        }

        this.setState({
            list: filteredList
        });
    }

    handleViewRegistration = (id: number) => {
        let donorData = _.cloneDeep(this.state.list).find(x => x.donorId == id);

        let data: ISwapDonor = {
            ...donorData,
            originalFromDate: donorData.donationStartDate,
            originalToDate: donorData.donationEndDate,
            centerId: donorData.centerId,
            recipientId: donorData.recipientId,
            recipientAlias: donorData.recipientAlias,
            recipientCenterId: donorData.recipientCenterId,
            recipientType: donorData.recipientType
        };

        this.props.getLookupData(id, data.centerId).then(response => {
            if (response.data.success) {
                let { donorChainId, clusterNumber, position } = response.data.results;
                let sortedList = this.stackAndSort(donorData.centerId, this.state.recipientList);

                if (this.props.isAdmin) {
                    data = {
                        ...data,
                        donorChainId,
                        clusterNumber,
                        position
                    }
                }

                this.setState({
                    view: {
                        show: true,
                        data,
                        lookupData: response.data.results
                    },
                    isPaired: data.isPaired,
                    pairedRecipientId: data.recipientId,
                    recipientList: sortedList,
                    donorId: id
                }, () => {
                    this.setUrlParameters();
                });
            }
        });
    }

    stackAndSort = (centerId: number, recipientList: ICenterRecipient[]): ICenterRecipient[] => {
        let chosenRecipients = recipientList.filter(recipient => recipient.centerId === centerId);

        recipientList = recipientList.filter(recipient => recipient.centerId !== centerId);
        recipientList.sort((a, b) => a.centerAlias.localeCompare(b.centerAlias));
        recipientList = chosenRecipients.concat(recipientList);

        return recipientList;
    }

    handleSendSelfRegistrationInvite = (id: number) => {
        this.props.sendSelfRegistrationInvite(id).then(response => {
            if (response.data.success) {
                toast.success('Voucher Self Registration Email Succesfully sent');
            } else {
                toast.error('Voucher Self Registration Email was unable to be processed');
            }
        })
    }

    handleValidate = (data: ISwapDonor) => {
        if (this.props.isAdmin) {
            let regex = new RegExp('^[a-zA-Z0-9]{1,12}$');

            if (!regex.test(data.alias)) {
                return toast.error("Alias must contain only letters and numbers and be between 1 to 10 characters")
            } else {
                this.props.checkAlias(data.donorId, data.alias).then((res) => {
                    if (!res.data.success) {
                        return toast.error("Alias already exists, please create a new one...")
                    } else {
                        this.handleSave(data)
                    }
                })
            }
        } else {
            this.handleSave(data);
        }
    }

    handleSave = (data: ISwapDonor) => {
        let doSave = this.props.isAdmin ? this.props.doAdminSave : this.props.doCenterSave;

        this.props.showLoading('Saving donor data, one moment please...').then(() => {
            doSave(data)
                .then(response => {
                    let newCenter = this.state.view.lookupData.centerList.find(item => item.id == data.centerId);
                    let newStatus = this.state.view.lookupData.statusList.find(item => item.id == data.statusId);
                    let donorResult = response.data.results;

                    let list = _.cloneDeep(this.state.list).map(item => {
                        if (item.donorId == data.donorId) {
                            item.centerAlias = newCenter.description;
                            item.centerId = data.centerId;
                            item.donationType = data.donationType;
                            item.donationTypeId = data.donationTypeId;
                            item.alias = data.alias;
                            item.mrn = data.mrn;
                            item.isDeleted = data.isDeleted;
                            item.isActive = data.isActive;
                            item.gender = data.gender;
                            item.bloodType = data.bloodType;
                            item.status = newStatus.description;
                            item.statusId = data.statusId;
                            item.donated = data.donated;
                            item.age = donorResult.age;
                            item.recipientId = data.recipientId;
                            item.recipientCenterId = data.recipientCenterId,
                                item.recipientAlias = data.recipientAlias,
                                item.recipientType = data.recipientType,
                                item.rdnCenterId = data.rdnCenterId;
                            item.adpRecipientId = data.adpRecipientId;
                            item.isRealTimeSwapFailure = data.isRealTimeSwapFailure;
                            item.isAddBackCredit = data.isAddBackCredit;
                        }

                        return item;
                    });

                    this.setState({
                        list
                    }, () => {
                        toast.success('Donor data saved successfully...');
                    });
                })
                .catch((error: AxiosError) => {
                    toast.error(
                        <>
                            <div>Unable to save donor data records:</div>
                            <div>{error.message}</div>
                        </>
                    );
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        })
    }

    handleAdminSave = (data: ISwapDonor) => {

    }

    handleCancelView = () => {
        this.setState({
            view: {
                show: false,
                data: null,
                lookupData: null
            },
            donorId: 0
        }, () => {
            this.setUrlParameters();
        });
    }

    handleDataChange = (data: ISwapDonor) => {
        this.setState({
            view: { ...this.state.view, data }
        });
    }

    handleSelectAction = (id: number, action: DonorAction) => {
        let data = this.state.list.find(x => x.donorId == id);

        if (action == DonorAction.Delete) {
            this.handleShowDeleteDonor(data.donorId, data.alias);
        }

        if (action == DonorAction.View) {
            this.handleViewRegistration(id);
        }

        if (action == DonorAction.SendEmail) {
            this.handleSendSelfRegistrationInvite(id);
        }

        if (action == DonorAction.ConvertDonorType) {
            this.handleShowDonorConversionFromActions(id)
        }

        if (action == DonorAction.AddMicrositeVoucherHolder) {
            this.handleShowVoucherHolderMicrositeRecipient(id);
        }

        if (action == DonorAction.OrderTissueTyping) {
            this.handleCheekSwabRequest(id, action);
        }

        if (action == DonorAction.UtilizeBulkCheekSwabKit) {
            this.handleCheekSwabRequest(id, action);
        }

        if (action == DonorAction.PrintRequisition) {
            this.handlePrintRequisition(data.requisitionId, HistogeneticsEntityType.Donor);
        }
    }

    handleSideBarAction = (action: DonorAction) => {
        let id = this.state.view.data.donorId;
        this.handleSelectAction(id, action);
    }

    handleShowDeleteDonor = (deleteDonorId: number, deleteDonorAlias: string) => {
        this.setState({
            deleteModal: {
                show: true,
                donorId: deleteDonorId,
                donorAlias: deleteDonorAlias
            }
        });
    }

    handleHideDeleteDonor = () => {
        this.setState({
            deleteModal: {
                show: false,
                donorId: 0,
                donorAlias: ''
            }
        });
    }

    handleDeleteDonor = (reasonCode: number, reason: string, initials: string) => {
        let { centerId } = this.props;
        let { donorId } = this.state.deleteModal;

        let doDelete = this.props.isAdmin ? this.props.doAdminDelete(donorId, reasonCode, reason, initials) : this.props.doCenterDelete(donorId, centerId, reasonCode, reason, initials);

        this.props.showLoading('Deleting donor, one moment please...').then(() => {
            doDelete
                .then(res => {
                    if (res.data.success) {
                        toast.success('Donor succesfully deleted...')

                        this.setState({
                            deleteModal: {
                                show: false,
                                donorId: 0,
                                donorAlias: '',
                            },
                            view: {
                                show: false,
                                data: null,
                                lookupData: null
                            }
                        }, () => {
                            this.getData();
                        });
                    }
                })
                .catch((err: AxiosError) => {
                    toast.error('Donor was unable to be deleted...');
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleShowDonorConversionFromActions = (donorId: number) => {
        this.props.showLoading('Retrieving conversion data, one moment please...').then(() => {
            this.props.getConversionLookUpData(donorId, this.props.centerId, this.props.isAdmin).then(response => {
                if (response.data.success) {
                    let { isPaired, hasIntended, isExpertSystem, hasDashReferral, typeList } = response.data.results;

                    this.setState({
                        donationTypeData: {
                            show: true,
                            donorId,
                            isPaired,
                            hasIntended,
                            isExpertSystem,
                            hasDashReferral,
                            typeList
                        }
                    });
                } else {
                    toast.error('Donation type data was unable to load...');
                }
            }).catch((error: AxiosError) => {
                toast.error('Donation type data was unable to load...');
            }).finally(() => {
                this.props.hideLoading();
            });
        })
    }

    handleHideDonorConversion = () => {
        this.setState({
            donationTypeData: initialDonationTypeDataState,
        })
    }

    handleDonorConversionAfterSave = () => {
        this.setState({
            donationTypeData: initialDonationTypeDataState,
        }, () => {
            this.getData();
        })
    }

    handleSaveDonorConversion = (data: IConvertDonationType, donorId: number) => {
        let { centerId } = this.props;

        this.props.showLoading('Converting donation type, please wait...').then(() => {
            this.props.convertDonor(donorId, centerId, data, this.props.isAdmin)
                .then(response => {
                    if (response.data.success) {
                        toast.success('Donation type successfully updated...')
                        this.handleDonorConversionAfterSave();
                    } else {
                        toast.error(response.data.message, { autoClose: false });
                    }
                })
                .catch((error: AxiosError) => {
                    toast.error('Donation type was unable to be converted...', { autoClose: false });
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleShowVoucherHolderMicrositeRecipient = (donorId: number) => {
        const donor = this.state.list.find(x => x.donorId == donorId);
        if (!donor) {
            return;
        }

        this.props.showLoading('Getting Microsite recipients, one moment please...').then(() => {
            this.props.getPedsMicrositeByCenter(this.props.centerId)
                .then(response => {
                    if (response.data.success) {
                        this.setState({
                            voucherHolderMicrositeRecipientModal: {
                                show: true,
                                donorId,
                                donorName: donor.fullName,
                                patientList: response.data.results.list
                            }
                        });
                    } else {
                        toast.error(response.data.message || 'Microsite recipients were unable to load...');
                    }
                })
                .catch(() => toast.error('Microsite recipients were unable to load...'))
                .finally(() => this.props.hideLoading());
        });
    }

    handleHideVoucherHolderMicrositeRecipient = () => {
        this.setState({
            voucherHolderMicrositeRecipientModal: {
                show: false,
                donorId: 0,
                donorName: '',
                patientList: []
            }
        });
    }

    handleConfirmVoucherHolderMicrositeRecipient = (micrositeRecipientId: number, voucherType: DonationType | '') => {
        const modal = this.state.voucherHolderMicrositeRecipientModal;
        const donor = this.state.list.find(x => x.donorId == modal.donorId);
        if (!donor || !micrositeRecipientId || voucherType == '') {
            return;
        }

        const data: IMicrositeConvertDonationType = {
            centerId: donor.centerId,
            donorId: donor.donorId,
            recipientId: null,
            donorRegistrationId: null,
            micrositeRecipientId,
            donationType: voucherType,
            conversionType: ConversionType.VoucherHolderMicrositeRecipient,
            donationDate: moment().format('YYYY-MM-DD')
        };

        this.props.showLoading('Adding Microsite voucher holder, one moment please...').then(() => {
            this.props.convertDonorToMicrositeVoucher(data)
                .then(response => {
                    if (response.data.success) {
                        toast.success('Microsite voucher holder added successfully...');
                        this.handleHideVoucherHolderMicrositeRecipient();
                        this.getData();
                    } else {
                        toast.error(response.data.message, { autoClose: false });
                    }
                })
                .catch(() => toast.error('Microsite voucher holder was unable to be added...', { autoClose: false }))
                .finally(() => this.props.hideLoading());
        });
    }

    handleCheekSwabRequest = (donorId: number, action: DonorAction) => {
        if (action == DonorAction.OrderTissueTyping) {
            let data = this.state.list.find(x => x.donorId == donorId);

            if (!data.canOrderCheekSwab) {
                toast.warning(<span>A cheek swab order was placed within the past 24 hours.</span>, {
                    style: { backgroundColor: 'yellow', color: '#333', fontSize: 16 },
                    autoClose: false,
                    closeButton: (props) => <Button bsStyle='primary' bsSize='sm' onClick={props.closeToast}>Close</Button>,
                    icon: false
                });

                return;
            }

            this.setState({
                orderCheekSwabModal: {
                    show: true,
                    donorId,
                    centerId: data.centerId
                }
            });
        }

        if (action == DonorAction.UtilizeBulkCheekSwabKit) {
            this.setState({
                bulkCheekSwabModal: {
                    show: true,
                    donorId
                }
            });
        }
    };

    handleCancelCheekSwabModal = (cancel: boolean) => {
        let list = _.cloneDeep(this.state.list).map(x => {
            if (x.donorId == this.state.cheekSwabModal.donorId) {
                if (!cancel) {
                    x.canOrderCheekSwab = false;
                }
            }

            return x;
        });

        this.setState({
            list,
            cheekSwabModal: {
                show: false,
                type: null,
                donorId: 0
            }
        });
    };

    handleCancelOrderCheekSwabModal = () => {
        this.setState({
            orderCheekSwabModal: {
                show: false,
                donorId: 0,
                centerId: 0
            }
        });
    };


    handleSuccessOrderCheekSwabModal = () => {
        let list = _.cloneDeep(this.state.list).map(x => {
            if (x.donorId == this.state.orderCheekSwabModal.donorId) {
                x.canOrderCheekSwab = false;
            }
            return x;
        });

        this.setState({
            list,
            orderCheekSwabModal: {
                show: false,
                donorId: 0,
                centerId: 0
            }
        });
    };

    handleCancelBulkCheekSwabModal = () => {
        this.setState({
            bulkCheekSwabModal: {
                show: false,
                donorId: 0
            }
        });
    };


    handleSuccessBulkCheekSwabModal = () => {
        this.setState({
            bulkCheekSwabModal: {
                show: false,
                donorId: 0
            }
        });
    };

    handlePrintRequisition = (requsitionId: number, entityTypeId: number) => {
        this.props.showLoading('Downloading requisition file, one moment please...').then(() => {
            this.props.printRequisition(requsitionId, entityTypeId).then((response: any) => {
                downloadFile(response.data, `requisition-file.pdf`, 'application/pdf');

                this.props.hideLoading();
            });
        });
    }

    render = () => {
        return (
            <>
                <div className='save-container' ref={this.saveContainer} />

                <div >
                    {!this.props.isAdmin && (
                        <SwapDonorsNav
                            activeKey={this.props.activeKey}
                            centerId={this.props.centerId}
                            donorId={0}
                            recipientId={0}
                            recipientAlias={''}
                            recipientCenterId={0}
                            recipientType={null}
                            isAdminLogin={this.props.groupIsSuper}
                            onTabChange={function (tab: string): void {
                                throw new Error('Function not implemented.');
                            }} />
                    )}

                    <div style={{ padding: '10px 10px 20px 10px' }}>
                        <Search
                            isAdmin={this.props.isAdmin}
                            fullName={this.state.fullName}
                            alias={this.state.alias}
                            email={this.state.email}
                            remote={this.state.remote}
                            dob={this.state.dob}
                            centerId={this.state.centerId}
                            showLimitWarning={this.state.total > this.state.list.length}
                            donatedStartDate={this.state.donatedStartDate}
                            donatedEndDate={this.state.donatedEndDate}
                            compatible={this.state.compatible}
                            voucherStatus={this.state.voucherStatus}
                            statusList={this.state.statusList}
                            typeList={this.state.typeList}
                            centerList={this.state.centerList}
                            onFilter={this.handleFilter}
                            onChange={this.handleFilterChange}
                        // onFullNameChange={this.handleFullNameChange}
                        // onAliasChange={this.handleAliasChange}
                        // onEmailChange={this.handleEmailChange}
                        // onRemoteChange={this.handleRemoteChange}
                        // onStatusChange={this.handleStatusChange}
                        // onTypeChange={this.handleTypesChange}
                        // onDobChange={this.handleDobChange}
                        // onCenterChange={this.handleCenterChange}
                        // onDonatedStartDateChange={this.handleDonatedStartDateChange}
                        // onDonatedEndDateChange={this.handleDonatedEndDateChange}
                        />

                        <Grid
                            list={this.state.list}
                            centerId={this.props.centerId}
                            isAdmin={this.props.isAdmin}
                            isSuper={this.props.groupIsSuper}
                            onAction={this.handleSelectAction}
                            onView={this.handleViewRegistration}
                        />

                        {this.state.list.length < this.state.total && (
                            <div>{this.state.list.length}/{this.state.total} {this.state.list.length > 1 ? 'donors' : 'donor'}</div>
                        )}
                    </div>
                </div>

                <Drawer
                    width="39vw"
                    placement="right"
                    getContainer={this.getContainer}
                    open={this.state.view.show}
                >
                    <div style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                        <div style={{ padding: 10 }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                                <div style={{ width: '39%' }}>
                                    <h3 style={{ margin: 0 }}>Donor Profile</h3>
                                </div>

                                <div style={{ width: '27%' }}>
                                    <ActionButtonRenderer
                                        donorId={this.state.view.data != null ? this.state.view.data.donorId : 0}
                                        centerId={this.props.centerId}
                                        donorCenterId={this.state.view.data != null ? this.state.view.data.centerId : 0}
                                        canDelete={this.state.view.data != null ? this.state.view.data.canDelete : false}
                                        canConvert={this.state.view.data != null ? this.state.view.data.canConvert : false}
                                        isAdp={this.state.view.data != null ? this.state.view.data.isAdp : false}
                                        statusId={this.state.view.data != null ? this.state.view.data.statusId : 0}
                                        wageAndTravelRequested={this.state.view.data != null ? this.state.view.data.wageAndTravelRequested : false}
                                        registrationId={this.state.view.data != null ? this.state.view.data.registrationId : 0}
                                        recipientId={this.state.view.data != null ? this.state.view.data.recipientId : 0}
                                        recipientCenterId={this.state.view.data != null ? this.state.view.data.recipientCenterId : 0}
                                        recipientType={this.state.view.data != null ? this.state.view.data.recipientType : null}
                                        orderId={this.state.view.data != null ? this.state.view.data.requisitionId : 0}
                                        isAdmin={this.props.isAdmin}
                                        isSuper={this.props.groupIsSuper}
                                        menuLocation={MenuLocation.Sidebar}
                                        canOrderCheekSwab={this.state.view.data != null ? this.state.view.data.canOrderCheekSwab : false}
                                        onMenuToggle={function (show: boolean): void {
                                            throw new Error('Function not implemented.');
                                        }}
                                        onItemSelected={this.handleSideBarAction}
                                    />
                                </div>

                                <div style={{ width: '33%', textAlign: 'right' }}>
                                    <Button bsStyle='link' bsSize='sm' onClick={this.handleCancelView}><Glyphicon glyph='remove' /></Button>
                                </div>
                            </div>

                            <View
                                isAdmin={this.props.isAdmin}
                                isSuper={this.props.groupIsSuper}
                                data={this.state.view.data}
                                centerList={this.state.centerList}
                                donationTypeList={this.state.donationTypeList}
                                rdnCenterList={this.state.rdnCenterList}
                                lookupData={this.state.view.lookupData}
                                donorTypeList={this.state.donorTypeList}
                                isPaired={this.state.isPaired}
                                recipientList={this.state.recipientList}
                                onDataChange={this.handleDataChange}
                                onSave={this.handleValidate}
                            />
                        </div>

                        <div className='text-center bg-info'>
                            <Button bsStyle='link' block onClick={this.handleCancelView}>Close This View</Button>
                        </div>
                    </div>
                </Drawer>

                <DeleteDonorModal
                    show={this.state.deleteModal.show}
                    alias={this.state.deleteModal.donorAlias}
                    onCancel={this.handleHideDeleteDonor}
                    onDelete={this.handleDeleteDonor}
                />

                <ConvertDonorType
                    show={this.state.donationTypeData.show}
                    donorId={this.state.donationTypeData.donorId}
                    isPaired={this.state.donationTypeData.isPaired}
                    hasIntended={this.state.donationTypeData.hasIntended}
                    isExpertSystem={this.state.donationTypeData.isExpertSystem}
                    hasDashReferral={this.state.donationTypeData.hasDashReferral}
                    isAdmin={this.props.isAdmin}
                    typeList={this.state.donationTypeData.typeList}
                    onSave={this.handleSaveDonorConversion}
                    onCancel={this.handleHideDonorConversion}
                />

                <CheekSwabRequest
                    centerId={this.props.centerId}
                    donorId={this.state.cheekSwabModal.donorId}
                    recipientId={0}
                    isModal={true}
                    show={this.state.cheekSwabModal.show}
                    type={this.state.cheekSwabModal.type}
                    onFinished={this.handleCancelCheekSwabModal}
                />

                {/* KIT REQUEST INTEGRATION: Individual cheek swab ordering modal */}
                <OrderCheekSwabModal
                    show={this.state.orderCheekSwabModal.show}
                    donorId={this.state.orderCheekSwabModal.donorId}
                    centerId={this.state.orderCheekSwabModal.centerId}
                    onCancel={this.handleCancelOrderCheekSwabModal}
                    onSuccess={this.handleSuccessOrderCheekSwabModal}
                />

                {/* KIT REQUEST INTEGRATION: Bulk cheek swab ordering modal */}
                <BulkCheekSwabModal
                    show={this.state.bulkCheekSwabModal.show}
                    donorId={this.state.bulkCheekSwabModal.donorId}
                    onCancel={this.handleCancelBulkCheekSwabModal}
                    onSuccess={this.handleSuccessBulkCheekSwabModal}
                />

                <VoucherHolderMicrositeRecipientModal
                    show={this.state.voucherHolderMicrositeRecipientModal.show}
                    donorName={this.state.voucherHolderMicrositeRecipientModal.donorName}
                    patientList={this.state.voucherHolderMicrositeRecipientModal.patientList}
                    onHide={this.handleHideVoucherHolderMicrositeRecipient}
                    onConfirm={this.handleConfirmVoucherHolderMicrositeRecipient}
                />
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        groupIsSuper: appState.app.user.group.isSuper,
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        doAdminDonorSearch: (request) => {
            return dispatch(DonorSwapActionCreators.doAdminDonorSearch(request));
        },
        doCenterDonorSearch: (request) => {
            return dispatch(DonorSwapActionCreators.doCenterDonorSearch(request));
        },
        getSwapDonorsLookupData: (centerId) => {
            return dispatch(DonorSwapActionCreators.getSwapDonorsLookupData(centerId));
        },
        doAdminSave: (data: ISwapDonor) => {
            return dispatch(DonorSwapActionCreators.doAdminSave(data));
        },
        doCenterSave: (data: ISwapDonor) => {
            return dispatch(DonorSwapActionCreators.doCenterSave(data));
        },
        getLookupData: (donorId, centerId) => {
            return dispatch(DonorSwapActionCreators.getLookUpData(donorId, centerId));
        },
        doAdminDelete: (donorId, reasonCode, reason, initials) => {
            return dispatch(DonorSwapActionCreators.doAdminDelete(donorId, reasonCode, reason, initials))
        },
        doCenterDelete: (donorId, centerId, reasonCode, reason, initials) => {
            return dispatch(DonorSwapActionCreators.doCenterDelete(donorId, centerId, reasonCode, reason, initials))
        },
        adminSpecificDonor: (donorId) => {
            return dispatch(DonorSwapActionCreators.doSpecificAdminDonorSearch(donorId))
        },
        checkAlias: (donorId, alias) => {
            return dispatch(DonorSwapActionCreators.checkAlias(donorId, alias))
        },
        sendSelfRegistrationInvite: (donorId) => {
            return dispatch(DonorSwapActionCreators.sendSelfRegistrationInvite(donorId));
        },
        getPairingRecipientList: () => {
            return dispatch(DonorSwapActionCreators.getPairingRecipientList())
        },
        savePairingRecipient: (centerId, donorId, recipientId) => {
            return dispatch(DonorSwapActionCreators.savePairingRecipient(centerId, donorId, recipientId))
        },
        getConversionLookUpData: (donorId, centerId, isAdmin) => {
            return dispatch(DonorSwapActionCreators.getConversionLookUpData(donorId, centerId, isAdmin))
        },
        convertDonor: (donorId, centerId, data, isAdmin) => {
            return dispatch(DonorSwapActionCreators.convertDonor(donorId, centerId, data, isAdmin));
        },
        getPedsMicrositeByCenter: (centerId) => {
            return dispatch(MicrositeActionCreators.getPedsMicrositeList(centerId));
        },
        convertDonorToMicrositeVoucher: (data) => {
            return dispatch(MicrositeActionCreators.convertDonor(data));
        },
        unlinkRecipient: (donorId) => {
            return dispatch(DonorSwapActionCreators.unlinkRecipient(donorId))
        },
        printRequisition: (orderId, entityType) => {
            return dispatch(ExpertSystemActionCreators.printRequisition(orderId, entityType));
        },
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(SwapDonorList);
